import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from '../../utils/BackgroundJobs';
import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import SalesRefundPostMutation from '../../graphql/mutations/salesLedger/SalesRefundPostMutation.graphql';
import SalesRefundPostingPreview from '../../graphql/entities/salesLedger/SalesRefundPostingPreview';
import SalesRefundTransactions from '../../graphql/entities/salesLedger/SalesRefundTransactions';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';
import { DocumentStatus, ISalesRefund } from '../../graphql/schema/p4types';

const displayPreview: (refund: ISalesRefund) => boolean = (refund) => {
  if (refund && refund.documentStatus) {
    return refund.documentStatus === DocumentStatus.Draft || refund.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const displayPosted: (refund: ISalesRefund) => boolean = (refund) => {
  if (refund && refund.documentStatus) {
    return refund.documentStatus === DocumentStatus.Posted;
  }
  return false;
};

const canBePosted: (refund: ISalesRefund) => boolean = (refund) => {
  if (refund && refund.documentStatus) {
    return refund.documentStatus === DocumentStatus.Draft || refund.documentStatus === DocumentStatus.Released;
  }
  return false;
};

const postRefund: (props: any) => void = (props) => {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(SalesRefundPostMutation, input, props, 'back', 'Post Refund', null);
};

const SALES_REFUND_POSTING_PREVIEW = createPostingPreview(SalesRefundPostingPreview);
const SALES_REFUND_POSTED_TRANSACTIONS = createPostedTransactions(SalesRefundTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: SALES_REFUND_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/salesLedger/SalesRefund',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: SALES_REFUND_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/salesLedger/SalesRefund',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Post Refund',
    component: PostSelectButton,
    performSave: true,
    fn: postRefund,
    individualButton: true,
    saveMessage: 'Refund Posted',
    condition: canBePosted,
  },
];
